import type { ProgramGuideItem} from "@ca.vmedia.tv/domains";
import { ProgramCardData } from "@/components/Cards/types";
import { useFavoriteProgramsStore } from "@/stores/FavoritesPrograms";
import { Logger } from '@/utils';
import type { AxiosError } from 'axios';
import type { ExposeInterface } from './types';

export const useShowAllMyTvProgramsStore = defineStore('ShowAllMyTvPrograms', (): ExposeInterface => {
    const FavoriteProgramsStore = useFavoriteProgramsStore();
    const {
        getFavoritePrograms
    } = storeToRefs(FavoriteProgramsStore);

    const { fetchFavoritePrograms, fetchFavoriteProgramsNextPage, clearSoft } = FavoriteProgramsStore;


    const _favoritesProgramsItems = computed((): ProgramGuideItem[] => getFavoritePrograms.value?.items ?? []);
    const getCardsPrograms = computed((): ProgramCardData[] => _favoritesProgramsItems.value.map((item: ProgramGuideItem) => new ProgramCardData(item)));

    const _isFavoritesProgramsLoading: Ref<boolean> = ref(false);
    const getIsFavoritesProgramsLoading = computed((): boolean => _isFavoritesProgramsLoading.value);

    const loadFavoritesPrograms = async (): Promise<void> => {
        try {
            _isFavoritesProgramsLoading.value = true;
            await fetchFavoritePrograms();
        } catch (error) {
            Logger.captureError(error as AxiosError | Error);
        } finally {
            _isFavoritesProgramsLoading.value = false;
        }
    };
    const loadFavoritesProgramsNextPage = async (): Promise<void> => {
        if (_isFavoritesProgramsLoading.value === true
            || !getFavoritePrograms.value?.paging?.pageNumber
            || !getFavoritePrograms.value?.paging.totalPages
            || (getFavoritePrograms.value.paging.pageNumber >= getFavoritePrograms.value.paging.totalPages)
        ) {
            return;
        }

        try {
            _isFavoritesProgramsLoading.value = true;
            await fetchFavoriteProgramsNextPage();
        } catch (error) {
            Logger.captureError(error as AxiosError | Error);
        } finally {
            _isFavoritesProgramsLoading.value = false;
        }
    };

    const clearAll = (): void => {
        clearSoft();
    };


    return {
        getCardsPrograms,
        getIsFavoritesProgramsLoading,
        loadFavoritesPrograms,
        loadFavoritesProgramsNextPage,
        clearAll
    };
});
